import styled from 'styled-components';

import { size } from '../layout/helpers';
import { theme } from '../layout/theme';

const InputSearchVariables = {
  height: '48px',
  heightLtMd: '40px',
};

export const StyledInputSearch = styled.div.attrs(() => ({
  role: 'search',
}))`
  position: relative;
  color: ${theme.colors.text.main};
  z-index: 1;
`;

export const SearchBar = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: ${InputSearchVariables.height};
  background-color: ${theme.colors.bg.accent};
  border: 1px solid ${theme.colors.border.main};
  border-radius: 24px;
  padding: 0 ${size(3)};

  &.form-input {
    background-color: ${theme.colors.bg.main};
  }

  &.qs-open {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  ${theme.screens.LtMd} {
    height: ${InputSearchVariables.heightLtMd};
    padding: 0 ${size(2.5)};
  }
`;

export const Icon = styled.div`
  flex-shrink: 0;
  cursor: default;
  font-size: 20px;
`;

export const Input = styled.input.attrs(() => ({
  type: 'search',
}))`
  flex: 1 1 auto;
  display: block;
  width: 100%;
  height: ${InputSearchVariables.height};
  padding: 0;
  padding-left: ${size(1.5)};
  background-color: transparent;
  border: 0;
  border-radius: 0;
  font-family: inherit;
  font-weight: ${theme.font.weight.regular};
  font-size: inherit;
  line-height: inherit;
  appearance: none;
  -webkit-appearance: none;
  touch-action: manipulation;

  &:focus {
    outline: none;
  }

  &::-webkit-input-placeholder {
    font-family: inherit;
    font-weight: ${theme.font.weight.regular};
    color: ${theme.colors.text.alt};
  }

  &:-moz-placeholder {
    font-family: inherit;
    font-weight: ${theme.font.weight.regular};
    color: ${theme.colors.text.alt};
  }

  &::-moz-placeholder {
    font-family: inherit;
    font-weight: ${theme.font.weight.regular};
    color: ${theme.colors.text.alt};
  }

  &:-ms-input-placeholder {
    font-family: inherit;
    font-weight: ${theme.font.weight.regular};
    color: ${theme.colors.text.alt};
  }

  &::-webkit-search-cancel-button {
    display: none;
  }

  ${theme.screens.LtMd} {
    height: ${InputSearchVariables.heightLtMd};
  }
`;

export const Foldout = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: ${theme.colors.bg.main};
  padding: ${size(2)};
  border: 1px solid ${theme.colors.border.main};
  border-top: 0;
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;
`;

export const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const Item = styled.li``;

export const Link = styled.a`
  position: relative;
  display: block;
  padding: ${size(0.75)} ${size(1)};
  text-decoration: none;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: ${theme.colors.bg.accent};
    border-radius: 3px;
    opacity: 0;
    pointer-events: none;
  }

  &.has-focus {
    &:before {
      opacity: 1;
    }
  }

  &:hover {
    text-decoration: none;
  }
`;

export const LinkContent = styled.span`
  position: relative;
  display: block;
  z-index: 1;
`;

export const UiBlock = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: -1;
`;
